type DeferredClerkWindow = Window & {
  __waypointLoadDeferredClerk?: () => void;
};

export const loadDeferredClerk = (): void => {
  if (typeof window === "undefined") return;

  (window as DeferredClerkWindow).__waypointLoadDeferredClerk?.();
};
